/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbTypeFinancementDto
 */
export interface FcbTypeFinancementDto {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeFinancementDto
     */
    idfinancementType?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeFinancementDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeFinancementDto
     */
    code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeFinancementDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbTypeFinancementDto interface.
 */
export function instanceOfFcbTypeFinancementDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeFinancementDtoFromJSON(json: any): FcbTypeFinancementDto {
    return FcbTypeFinancementDtoFromJSONTyped(json, false);
}

export function FcbTypeFinancementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeFinancementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idfinancementType': !exists(json, 'idfinancementType') ? undefined : json['idfinancementType'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbTypeFinancementDtoToJSON(value?: FcbTypeFinancementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idfinancementType': value.idfinancementType,
        'libelle': value.libelle,
        'code': value.code,
        'actif': value.actif,
    };
}

